import { useEffect, useState } from 'react';
import { NotFound } from '../../../components/NotFound';
import { useAuth } from '../../../contexts/AuthProvider';
import { formatDate, numberDisplay, parseFixed, removeLastFragment } from '../../../services/formats';
import { Table } from 'react-bootstrap';
import { useUtility } from '../../../contexts/UtilityContext';
import { fetchRptItemSaleOrderBalance, RptItemSaleOrderBalanceModel } from '../../../model/sale-order.model';

interface IOwnProps {
  id?: number;
}

export default function ItemSaleOrderBalance({ id }: IOwnProps) {
  const { isLoading, showLoader, hideLoader } = useUtility();
  const [balanceList, setBalanceList] = useState<Record<string, Array<RptItemSaleOrderBalanceModel>>>({});
  const { authInfo } = useAuth();

  useEffect(() => {
    async function fetchData() {
      if (id) {
        try {
          showLoader();
          const data = await fetchRptItemSaleOrderBalance(id, authInfo);

          Object.entries(data).forEach(([key, value]) => {
            let balance = 0;
            value.forEach((item) => {
              balance += parseFixed(item.qty);
              item.balance = balance;
            });

            setBalanceList((prev) => ({
              ...prev,
              [key]: value,
            }));
          });
        } catch (err) {
          alert(err);
        } finally {
          hideLoader();
        }
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInfo, id]);

  return (
    <>
      {!isLoading && !Object.keys(balanceList).length ? <NotFound /> : <>
        {Object.entries(balanceList).map(([ac_name_id, list], idx) => (
          <Table striped bordered hover responsive width="100%" key={`group-fragment-${idx}`}>
            <thead>
              <tr>
                <th className='text-start'>BUYER</th>
                <th className='text-center'>NO</th>
                <th className='text-center'>DATE</th>
                <th className='text-end'>QNTY</th>
                <th className='text-end'>BALANCE</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => (
                <tr key={`account-ledger-${index}`}>
                  <td className='text-start'>{removeLastFragment(ac_name_id)}</td>
                  <td className='text-center'>{item.v_no}</td>
                  <td className='text-center'>{formatDate(item.v_date)}</td>
                  <td className='text-end'>{numberDisplay(item.qty)}</td>
                  <td className='text-end'>{numberDisplay(item.balance)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ))}
      </>
      }
    </>
  );
};